import React from 'react';
import PropTypes from 'prop-types';

import {
    PlayerRow,
    VerifiedUtrIcons,
    InsightBlock,
    hasCardInsight,
} from '../../NewStatsTabContent/PerformanceStats/GameCardTooltip';
import { lockHandlerPropType } from '../../NewStatsTabContent/PerformanceStats/performanceStatsUtils';

import styles from './performanceStatsResults.scss';

function PerformanceResultCard({ card, locked, onLockClick, 'data-testid': dataTestId }) {
    const { match } = card;
    const showInsight = hasCardInsight(card, locked);
    return (
        <div className={styles.card} data-testid={dataTestId}>
            <div className={styles.cardHeader} data-testid={dataTestId && `${dataTestId}.header`}>
                <span className={styles.cardDateGroup}>
                    <span className={styles.cardDate} data-testid={dataTestId && `${dataTestId}.date`}>{card.shortDateLabel}</span>
                    <VerifiedUtrIcons classes={styles} data-testid={dataTestId} />
                </span>
            </div>
            {(match || showInsight) && (
                <div className={styles.scoresSection} data-testid={dataTestId && `${dataTestId}.scores-section`}>
                    {match && (
                        <React.Fragment>
                            <PlayerRow
                                player={match.me}
                                sets={match.sets}
                                isWinner={match.profileIsWinner}
                                classes={styles}
                                data-testid={dataTestId && `${dataTestId}.player`}
                            />
                            <PlayerRow
                                player={match.opponent}
                                sets={match.sets}
                                isOpponent
                                isWinner={!match.profileIsWinner}
                                classes={styles}
                                data-testid={dataTestId && `${dataTestId}.opponent`}
                            />
                        </React.Fragment>
                    )}
                    <InsightBlock
                        card={card}
                        locked={locked}
                        onLockClick={onLockClick}
                        classes={styles}
                        data-testid={dataTestId}
                    />
                </div>
            )}
        </div>
    );
}

PerformanceResultCard.propTypes = {
    card: PropTypes.shape({
        shortDateLabel: PropTypes.string,
        insight: PropTypes.shape({
            percentLabel: PropTypes.string,
            direction: PropTypes.string,
        }),
        impactWeight: PropTypes.string,
        match: PropTypes.shape({
            me: PropTypes.shape({}),
            opponent: PropTypes.shape({}),
            profileIsWinner: PropTypes.bool,
            sets: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }).isRequired,
    locked: PropTypes.bool,
    onLockClick: lockHandlerPropType,
    'data-testid': PropTypes.string,
};

PerformanceResultCard.defaultProps = {
    locked: false,
    onLockClick: null,
    'data-testid': null,
};

export default PerformanceResultCard;
